module.exports = __webpack_public_path__ + "static/media/calender.6fb27362.svg";